import styled from 'styled-components';

import { NetworkStatus, PAYER_TYPES, StatusField } from 'models/GroupPayerNetworkStatus';
import { colors } from 'styles/theme/colors';
import { BodySmall, BodySmallBold } from 'styles/typography';

import { StatusToggle } from './NetworkStatusTable';

export type Statuses = Record<StatusField, NetworkStatus>;

export const NOT_SET: Statuses = { commercial: null, managedMedicare: null, managedMedicaid: null, other: null };

type StatusFieldsProps = { intro: string; value: Statuses; onChange: (next: Statuses) => void };

export default function StatusFields({ intro, value, onChange }: StatusFieldsProps) {
  return (
    <div>
      <Intro>{intro}</Intro>
      <Card>
        {PAYER_TYPES.map(({ field, label }) => (
          <Row key={field}>
            <BodySmallBold>{label}</BodySmallBold>
            <StatusToggle
              label={label}
              value={value[field]}
              onChange={(status) => onChange({ ...value, [field]: status })}
            />
          </Row>
        ))}
      </Card>
    </div>
  );
}

const Intro = styled(BodySmall)`
  display: block;
  margin-bottom: 8px;
  color: ${colors.black75};
`;

const Card = styled.div`
  border: 1px solid ${colors.black10};
  border-radius: 4px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;

  & + & {
    border-top: 1px solid ${colors.black10};
  }
`;
